;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    url: {
      default: false
    },
    title: {
      default: "Confirm"
    },
    beforeSubmit: {
      default: function _default() {
        return function () {
          return _promise2.default.resolve(true);
        };
      }
    },
    message: {
      default: "Are you sure you want to do this?"
    },
    ajax: {
      default: true
    },
    method: {
      default: "GET"
    },
    actionClass: {
      default: ""
    },
    actionStyle: {
      default: function _default() {
        return {};
      }
    },
    actionText: {
      default: "Confirm"
    },
    payload: {
      default: function _default() {
        return {};
      }
    },
    cancelText: {
      default: "Cancel"
    },
    okText: {
      default: "Continue"
    },
    okBtnClass: {
      default: "btn-warning"
    },
    cancelBtnClass: {
      default: "btn-success"
    }
  },
  data: function data() {
    return {
      show: false,
      sending: false,
      csrf_token: this.$attrs["csrf_token"]
    };
  },

  computed: {
    requestMethod: function requestMethod() {
      var method = (this.method || "GET").toLowerCase();

      if (!(method === "get" || method === "post")) {
        method = "post";
      }

      return method;
    }
  },
  methods: {
    showModal: function showModal() {
      $(this.$el).parents(".dropdown-menu").css({ display: "block" });
      this.show = true;
    },
    doCancel: function doCancel() {
      $(this.$el).parents(".dropdown-menu").css({ display: "" });
      this.$emit("cancelled");
      this.show = false;
    },
    doAction: function doAction() {
      var _this = this;

      if (!this.url) {
        this.$emit("confirmed");
        this.show = false;
        return true;
      }

      if (typeof this.beforeSubmit === "function") {
        var proceed = this.beforeSubmit().then(function (proceed) {
          if (!proceed) {
            return false;
          }

          if (_this.ajax) {
            _this.performAjax();
          } else {
            _this.performRequest();
          }
        });
      } else {
        if (this.ajax) {
          this.performAjax();
        } else {
          this.performRequest();
        }
      }
    },
    performAjax: function performAjax() {
      var _this2 = this;

      this.sending = true;

      var data = new FormData(this.$refs["form"]);

      (0, _entries2.default)(this.payload).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        data.append(key, value);
      });

      var jsonObject = {};

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(data.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          jsonObject[key] = value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$http[this.method](this.url, jsonObject).then(function (response) {
        _this2.$emit("success", response.data);
        _this2.show = false;
      }).catch(function (error) {
        _this2.$emit("failed", error.response);
      }).finally(function () {
        _this2.sending = false;
      });
    },
    performRequest: function performRequest() {
      if (this.requestMethod === "get") {
        window.location.href = this.url;
      } else {
        this.$refs["form"].submit();
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline"},[_c('a',{class:_vm.actionClass,attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.showModal()}}},[_vm._v(_vm._s(_vm.actionText))]),_vm._v(" "),(_vm.show)?_c('modal',{on:{"close":function($event){_vm.doCancel()}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('form',{ref:"form",attrs:{"action":_vm.url,"method":_vm.requestMethod}},[_c('input',{attrs:{"type":"hidden","name":"_method"},domProps:{"value":_vm.method}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"_csrf_token"},domProps:{"value":_vm.csrf_token}}),_vm._v(" "),_c('div',[_vm._t("default",[_vm._v(_vm._s(_vm.message))])],2)])]),_vm._v(" "),_c('div',{staticClass:"text-right",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn",class:_vm.cancelBtnClass,on:{"click":function($event){$event.preventDefault();_vm.doCancel()}}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.okBtnClass,on:{"click":function($event){$event.preventDefault();_vm.doAction()}}},[(_vm.sending)?_c('span',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.okText)+"\n      ")])])]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22150865", __vue__options__)
  } else {
    hotAPI.reload("data-v-22150865", __vue__options__)
  }
})()}